// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import courseAnalysis from './decks/courseAnalysis';
import mlModel from './decks/mlModel';

/**
 * The presentations, shipped inside the JS bundle as complete HTML documents and keyed by the
 * route segment that opens them (`/documentation/<slug>`). Nothing here is a file the web server
 * hands out: the only way to a deck is the gated documentation screen, which renders the string.
 */
export const DECKS = {
  'course-analysis': { i18nKey: 'courseAnalysis', html: courseAnalysis },
  'ml-model': { i18nKey: 'mlModel', html: mlModel },
} as const;

export type DeckSlug = keyof typeof DECKS;

export const DECK_SLUGS = Object.keys(DECKS) as DeckSlug[];

export const isDeckSlug = (value: string | string[] | undefined): value is DeckSlug =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(DECKS, value);
